import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { nanoid } from '@reduxjs/toolkit';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { useEffect, useRef } from 'react';
import useTranslate from '../../../localization/helpers';
import './styles.scss';
var TextEditor = function (_a) {
    var value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var translate = useTranslate().translate;
    var editorRef = useRef(null);
    var quillRef = useRef(null);
    var toolBarId = nanoid();
    useEffect(function () {
        var handleChange = function () {
            var _a, _b;
            var content = (_b = (_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.root.innerHTML) !== null && _b !== void 0 ? _b : '';
            onChange(extractAndFixLinks(content));
        };
        if (editorRef.current) {
            quillRef.current = new Quill(editorRef.current, {
                theme: 'snow',
                placeholder: placeholder,
                readOnly: disabled,
                modules: {
                    toolbar: (_jsxs("div", { id: toolBarId, children: [_jsx("span", { className: 'ql-formats', children: _jsxs("select", { className: 'ql-header', children: [_jsx("option", { value: '1', children: translate('common.heading', { heading: 1 }) }), _jsx("option", { value: '2', children: translate('common.heading', { heading: 2 }) }), _jsx("option", { value: '3', children: translate('common.heading', { heading: 3 }) }), _jsx("option", { value: '4', children: translate('common.heading', { heading: 4 }) }), _jsx("option", { value: '', selected: true, children: translate('common.normal') })] }) }), _jsxs("span", { className: 'ql-formats', children: [_jsx("button", { className: 'ql-bold' }), _jsx("button", { className: 'ql-italic' }), _jsx("button", { className: 'ql-underline' })] }), _jsxs("span", { className: 'ql-formats', children: [_jsx("button", { className: 'ql-list', value: 'ordered' }), _jsx("button", { className: 'ql-list', value: 'bullet' })] }), _jsxs("span", { className: 'ql-formats', children: [_jsx("button", { className: 'ql-indent', value: '-1' }), _jsx("button", { className: 'ql-indent', value: '+1' })] }), _jsx("span", { className: 'ql-formats', children: _jsx("button", { className: 'ql-clean' }) })] }))
                }
            });
            quillRef.current.on('text-change', handleChange);
        }
        return function () {
            if (quillRef.current) {
                quillRef.current.off('text-change', handleChange);
                quillRef.current = null;
            }
        };
    }, []);
    var extractAndFixLinks = function (content) {
        var linkRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g;
        return content.replace(linkRegex, function (_, link) {
            var correctedLink = addProtocolToLink(link);
            return "<a href=\"".concat(correctedLink, "\"");
        });
    };
    var addProtocolToLink = function (url) {
        if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
            return "http://".concat(url);
        }
        return url;
    };
    useEffect(function () {
        if (quillRef.current && value !== quillRef.current.root.innerHTML) {
            quillRef.current.root.innerHTML = value;
        }
    }, [value]);
    return _jsx("div", { ref: editorRef, className: 'editor-container' });
};
export default TextEditor;
